export type MapUnit = 'mq' | 'm';

export interface IMapUnitRenderProps {
  value: number;
  unit?: MapUnit;
}

const UnitFormatter = new Intl.NumberFormat('it-IT', {
  style: 'decimal',
  maximumFractionDigits: 2,
  useGrouping: true,
});

export function formatMapUnit(value: number) {
  return `${UnitFormatter.format(value)} mq`;
}

export function renderMapUnit(unit: 'mq', value: number) {
  return `${UnitFormatter.format(value)} ${unit}`;
}

export function MapUnitRender(props: IMapUnitRenderProps) {
  const { value, unit = 'mq' } = props;
  if (!value) return null;
  if (unit === 'm') return <span>{formatMapLength(value)}</span>;
  return <span>{UnitFormatter.format(value)} mq</span>;
}

export function formatMapLength(value: number) {
  if (value >= 1000) {
    return `${UnitFormatter.format(value / 1000)} km`;
  }
  return `${UnitFormatter.format(value)} m`;
}
